export const DEFAULT_LANGUAGE = "az";
export const FALLBACK_LANGUAGE = "en";
export const SUPPORTED_LANGUAGES = ["az", "en", "ru", "tr"];
